import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import './VerificationBar.scss';
import Translate from '@securitize/ui-components/i18n/Translate/Translate';
import Cookies from 'js-cookie';
import SettingsCard from '../../views/Pages/components/SettingsCard/SettingsCard';
import SecuritizePage from '../SecuritizePage';

const VerificationBar = (props) => {
  const { user, issuerConfig, isLoading } = props;
  const { verificationStatus } = user;

  useEffect(() => {
    if (!isLoading && verificationStatus === 'verified') {
      Cookies.set(`${user.investorId}-${issuerConfig.issuerId}`, 'was-verified');
    }
  }, [verificationStatus, isLoading]);

  const show = Cookies.get(`${user.investorId}-${issuerConfig.issuerId}`) !== 'was-verified';

  const getInfoSubtitle = () => {
    switch (user.verificationStatus) {
      case 'pending':
        return 'Texts.pending-desc';
      case 'updates-required':
        return 'Texts.updates-required-desc';
      case 'verified':
      case 'not-verified':
        return 'Texts.to-use-securitize';

      case 'service-denied':
        return 'Texts.service-denied-desc';
      default:
        return '';
    }
  };
  const buildUrl = (step = 'type') => {
    const url = new URL(`${issuerConfig.securitizeIdUrl}/profile/verification/${step}`);

    url.searchParams.append('issuerId', issuerConfig.issuerId);
    url.searchParams.append('scope', 'info details verification');
    url.searchParams.append('redirecturl', window.location.href);

    return url.toString();
  };

  return (
    show && (
    <SecuritizePage isLoading={isLoading}>
      {user.verificationStatus !== 'verified'
      && (
      <div className="verification-bar">
        <p className="verification-bar__subtitle font-20">
          <Translate translationKey={getInfoSubtitle()} />
        </p>
        <Row>
          <Col lg={6} xl={4} className="mt-4">
            <SettingsCard
              done
              id="create-account-card"
              iconClassName="icon-details font-24"
              title="Texts.create-account"
              size="small"
              href="/profile"
            />
          </Col>
          <Col lg={6} xl={4} className="mt-4">
            {
              user.verificationStatus === 'not-verified' ? (
                <a
                  href={buildUrl('type')}
                >
                  <SettingsCard
                    id="complete-details-card"
                    iconClassName="icon-details font-24"
                    title="Texts.complete-details"
                    paragraph="Texts.personal-info-description"
                    size="small"
                  />
                </a>
              ) : user.verificationStatus === 'verified'
                ? (
                  <SettingsCard
                    done
                    id="verified-completed"
                    iconClassName="icon-details font-24"
                    title="Texts.complete-details"
                    size="small"
                  />
                )
                : (
                  <a href={buildUrl('check')}>
                    <SettingsCard
                      id="details-card"
                      status={user.verificationStatus}
                      iconClassName="icon-details font-24"
                      title="Texts.investor-details"
                      size="small"
                    />
                  </a>
                )
        }
          </Col>
        </Row>
      </div>
      )}
    </SecuritizePage>
    )
  );
};

VerificationBar.defaultProps = {
  user: {},
  isLoading: true,
  issuerConfig: {
    securitizeIdUrl: '',
    issuerName: '',
  },
};

VerificationBar.propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
  isLoading: PropTypes.bool,
  issuerConfig: PropTypes.shape({
    securitizeIdUrl: PropTypes.string,
    issuerName: PropTypes.string,
    issuerId: PropTypes.string,
  }),
};

const mapStateToProps = (state) => {
  const { auth: { user, isLoading }, issuerConfiguration } = state;
  return {
    user: user || {},
    isLoading: isLoading || issuerConfiguration.isLoading,
    issuerConfig: issuerConfiguration.config,
  };
};

export default connect(
  mapStateToProps,
  {},
)(VerificationBar);
